<template>
	<div class="page-box">
		<div class="table-box" :style="{ '--height': height }">
			<el-table :data="tableData" ref="unitRef" highlight-current-row :header-cell-style="{
        background: '#e4e4e4',
        border: 'none',
        color: '#000000',
        fontWeight: 'bolder',
        fontSize: '0.8rem',
        padding: '0.5rem',
      }" :cell-style="{ padding: '0.3rem', fontSize: '0.8rem' }" row-key="code" current-row-key="id"
				@row-click="handleRowClick" border
				style="width:100%;height: calc(100%);overflow-y: hidden;font-size: 0.8rem;"
				@selection-change="changeSelect">
				<el-table-column prop="" label="" width="50px" type="selection" align="center" reserve-selection>
				</el-table-column>
				<el-table-column prop="code" label="组别代码" width="80px" align="center">
					<template> </template>
				</el-table-column>
				<el-table-column prop="name" label="参赛组别">
				</el-table-column>
				<el-table-column prop="dance" label="舞种" width="100px">
				</el-table-column>
				<el-table-column prop="type" label="类型" align="center" width="70px">
					<template slot-scope="{row}">
						<div> {{ types[row.type] }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="teamName" label="赛制" align="center" width="70px">
					<template slot-scope="{row}">
						<div>{{ getMatchRulesStr(row.matchRules) }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="teamName" label="性别要求" align="center" width="80px">
					<template slot-scope="{row}">
						<div>{{ getgenderRequirementsStr(row.genderRequirements) }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="teamName" label="年龄限制" width="120px">
					<template slot-scope="{row}">
						<div>{{ getageStr(row) }}</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
				:page-sizes="[10, 20,30, 40, 80, 100]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
				:pager-count="5">
			</el-pagination>
		</div>
	</div>
</template>
<script>
	import {
		groupClassifyAddGroupDetails,
		pageWaitSelectGroups
	} from '../../../../../api/mymatchs/groupsetitem';

	export default {
		name: "add-group",
		data() {
			return {
				types: ["双人组", "多人组", "单人组", "不限"],
				totalNum: 0,
				pageSize: 30,
				currentPage: 1,
				tableData: [],
				matchId: '',
				currId: '',
				height: '375px',
				selList: [],

			};
		},
		created() {
			const {
				matchId
			} = this.$attrs.params;
			const {
				currId
			} = this.$attrs.params;
			if (matchId) {
				this.matchId = matchId;
				this.currId = currId;
				this.getPageLocal();
			}
		},
		mounted() {
			setTimeout(() => {
				this.height = this.$refs.unitRef.$el.clientHeight + 'px'
			}, 1000);
		},
		methods: {
			async getPageLocal() {
				const params = {
					currPage: this.currentPage,
					pageSize: this.pageSize,
					matchId: this.matchId,
					groupClassifyId: this.currId,
				}
				const res = await pageWaitSelectGroups(params);
				if (res && res.status == 200) {
					this.totalNum = res.data.total;
					this.tableData = res.data.list;
				} else {
					res && res.msg && this.$message.error(res.msg);
				}
			},
			sizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getPageLocal();
			},
			currentChange(val) {
				this.currentPage = val;
				this.getPageLocal();
			},
			handleRowClick() {

			},
			getTypeStr(genderRequirements) {
				const types = new Map([
					["0", "双人组"],
					["1", "多人组"],
					["3", "单人组"]
				]);
				if (types.has(genderRequirements)) {
					return types.get(genderRequirements);
				} else {
					return "双人组";
				}
			},
			getMatchRulesStr(matchRules) {
				const types = new Map([
					["0", "等级赛"],
					["1", "名次赛"],
					["2", "奖金赛"],
					["3", "不限"],
					["4", "淘汰赛"],
					["5", "精英赛 "],
					["6", "竞技赛 "],
					["7", "进阶赛 "],
				]);
				if (types.has(matchRules)) {
					return types.get(matchRules);
				} else {
					return "--";
				}
			},
			getgenderRequirementsStr(genderRequirements) {
				const types = new Map([
					["0", "不限"],
					["1", "男"],
					["2", "女"],
					["3", "男女"],
					["4", "女女"],
				]);
				if (types.has(genderRequirements)) {
					return types.get(genderRequirements);
				} else {
					return "不限";
				}
			},
			getageStr(row) {
				if ((row.minAge && row.minAge != 0) && (!row.maxAge || row.maxAge == 0)) {
					return `${row.minAge}岁及以上`;
				}
				if ((!row.minAge || row.minAge == 0) && (row.maxAge && row.maxAge != 0)) {
					return `${row.maxAge}岁及以下`;
				}
				if (row.minAge == row.maxAge && row.minAge > 0) {
					return `${row.maxAge}岁`;
				}
				if ((row.minAge && row.minAge != 0) && (row.maxAge && row.maxAge != 0) && row.minAge != row.maxAge) {
					return `${row.minAge}~${row.maxAge}岁`;
				}
				if ((!row.minAge || row.minAge == 0) || (!row.maxAge || row.maxAge == 0)) {
					return "不限";
				}
				return "--";
			},
			changeSelect(selVal) {
				this.selList = selVal;
			},
			async confirm(callback, close) {
				if (this.selList.length == 0) {
					this.$message.warning("请选择组别");
					return;
				}
				const groupCodeList = this.selList.map(itm => itm.code).filter(itm => itm);
				const res = await groupClassifyAddGroupDetails({
					groupCodeList: groupCodeList,
					id: this.$attrs.params.currId
				});
				if (res && res.status == 200) {
					this.$message.success("添加成功");
					callback();
					close();
				} else {
					res && res.msg && this.$message.error(res.msg);
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	.page-box {
		width: calc(100%);
		height: calc(100%);
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 1fr 40px;

		.table-box {
			overflow: hidden;
			height: var(--height);

			::v-deep [class*=is-indeterminate] [class~=el-checkbox__inner] {
				background-color: #F32C6C !important;
			}

			::v-deep .el-table__body-wrapper {
				height: calc(100% - 37px);
				overflow-y: auto;
			}
		}

		.page {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-left: 15px;
		}
	}
</style>